import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NewAuthInterceptor } from './new-auth.interceptor';

export const httpInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: NewAuthInterceptor, multi: true }];
